
export default function CountIndicator(count: number) {
  if (count === 0) return null;
  return (
    <div className="absolute -top-3 -right-3 rounded-full bg-red-500 text-white h-6 w-6 text-center">
      {count}
    </div>
  )
}